import { useLabeling } from '../../context/useLabeling';
import { BulkBar } from './BulkBar';
import { GridCard } from './GridCard';

export function GridMode() {
  const { filtered } = useLabeling();

  return (
    <div className="flex flex-col gap-4">
      <BulkBar />
      {/* Rows sized by their content (`auto-rows-max`), the page scrolls (see LabelingArea). The
          cards clip their overflow, which zeroes their minimum size: with plain `auto` rows a
          height-bounded grid shared its height between the rows instead of growing, and 200
          images became 200 thin lines. */}
      <div
        data-testid="grid-cards"
        className="grid auto-rows-max gap-4"
        style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(196px, 1fr))' }}
      >
        {filtered.map((item) => (
          <GridCard key={item.key} item={item} />
        ))}
      </div>
    </div>
  );
}
